import React from 'react'
import { createRoot } from 'react-dom/client'
import { App as AntApp, ConfigProvider } from 'antd'
import ruRU from 'antd/locale/ru_RU'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import { loadConfig } from './shared/config/runtime.config'
import { initApiService } from './shared/services/api'
import { AuthProvider } from './shared/contexts/AuthContext'
import 'antd/dist/reset.css'
import './index.css'

async function bootstrap() {
  await loadConfig()
  initApiService()

  createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <ConfigProvider
        locale={ruRU}
        theme={{
          token: {
            borderRadius: 8,
            colorBgLayout: '#f4f6f8',
            colorPrimary: '#2563eb',
            colorSuccess: '#16a34a',
            colorWarning: '#d97706',
            colorError: '#dc2626',
            fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
          },
          components: {
            Card: {
              borderRadiusLG: 10,
            },
            Table: {
              headerBg: '#f8fafc',
              headerColor: '#475569',
            },
          },
        }}
      >
        <AntApp>
          <BrowserRouter>
            <AuthProvider>
              <App />
            </AuthProvider>
          </BrowserRouter>
        </AntApp>
      </ConfigProvider>
    </React.StrictMode>,
  )
}

void bootstrap()
